import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./Kerosene.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";
import FurnacePerformance from "./FurnacePerformance";




function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}



function Kerosene() {

    useEffect(() => {
    
      trackPageVisit("Kerosene");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
  const {processData,  setProcessData} = useContext(ProcessContext);
  const [showPerformance,setShowPerformance] = useState(false);

     

  const DEFAULT_VALVES = {
  FCV_3701: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3702: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3703: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3704: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("Kerosene_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_3701: { ...DEFAULT_VALVES.FCV_3701, ...parsed.FCV_3701 },
      FCV_3702: { ...DEFAULT_VALVES.FCV_3702, ...parsed.FCV_3702 },
      FCV_3703: { ...DEFAULT_VALVES.FCV_3703, ...parsed.FCV_3703 },
      FCV_3704: { ...DEFAULT_VALVES.FCV_3704, ...parsed.FCV_3704 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("Kerosene_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================
    
                const { transmitters,  } = usePlantStore();
                const TT_28023 = transmitters.TT_28023 || 0;
                const PT_28023 = transmitters.PT_28023 || 0;
                const FIC_28023 = transmitters.FIC_28023 || 0;
  




  const xv3701Open = !valves?.XV_3701;
  const xv3702Open = !valves?.XV_3702;
  const xv3703Open = !valves?.XV_3703;
  const xv3704Open = !valves?.XV_3704;
  const xv3705Open = !valves?.XV_3705;
  const xv3706Open = !valves?.XV_3706;


    const FIC_3701 = FIC_28023;
    const PT_3701 = PT_28023;


    
/* =========================================================
              SPLITTING MAIN Kerosene LINE
========================================================= */

const openKeroseneTankSplit =
[
  xv3701Open,
  xv3702Open
].filter(Boolean).length;

const FIC_3702 =
  xv3701Open
    ? FIC_3701 / openKeroseneTankSplit
    : 0;

const FIC_3703 =
  xv3702Open
    ? FIC_3701 / openKeroseneTankSplit
    : 0;






/* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};
const togglePump = pumpContext.togglePump || (() => {});

/* =========================================================
   P-3701A / P-3701B STATUS
========================================================= */

const P3701A_Running =
pumpData?.["P-3701A"]?.running ?? false;

const P3701B_Running =
pumpData?.["P-3701B"]?.running ?? false;

const P3701_Running =
P3701A_Running || P3701B_Running;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P3701_CAPACITY = 12.5;


/* =========================================================
   CONTROL VALVE
========================================================= */

const FCV3701_Opening =
(valveData?.FCV_3701?.opening || 0) / 100;


/* =========================================================
   TARGET FLOW
========================================================= */

const targetFIC3704 =
(
P3701_Running
)
?
P3701_CAPACITY *
FCV3701_Opening
:
0;


/* =========================================================
   FLOW UPDATE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const current =
Number(prev.FIC_3704 || 0);

const next =
current +
(targetFIC3704-current)*0.12;

return{

...prev,

FIC_3704:
Number(next.toFixed(3))

};

});

},500);

return()=>clearInterval(timer);

},
[
targetFIC3704
]);



/* =========================================================
   PRESSURE + TEMPERATURE ENGINE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const currentPressure =
Number(prev.PT_3704 || 0.03);

const currentTemp =
Number(prev.TT_3704 || 28);

const currentFlow =
Number(prev.FIC_3704 || 0);

let targetPressure = 0.03;
let targetTemp = 28;


/* =========================================
   PUMP RUNNING
========================================= */

if(P3701_Running){

/* -----------------------------------------
   PRESSURE
----------------------------------------- */

// Dead-head (Valve fully closed)

if(FCV3701_Opening<=0){

targetPressure=1.80;

}

// Highly restricted

else if(FCV3701_Opening<0.20){

const restriction =
(0.20-FCV3701_Opening)/0.20;

targetPressure=
0.80+
restriction*
1.00;

}

// Normal operation

else{

targetPressure=
0.80-
(
FCV3701_Opening-
0.20
)*0.18;

}


/* -----------------------------------------
   TEMPERATURE
----------------------------------------- */

targetTemp=28;

// Dead-head heating

if(FCV3701_Opening<=0){

targetTemp=36;

}

// Restricted flow heating

else if(FCV3701_Opening<0.20){

const restriction=
(0.20-FCV3701_Opening)/0.20;

targetTemp=
28+
restriction*4;

}

}


/* =========================================
   UPDATE
========================================= */

return{

...prev,

PT_3704:
Number(
(
currentPressure+
(
targetPressure-currentPressure
)*0.08
).toFixed(3)
),

TT_3704:
Number(
(
currentTemp+
(
targetTemp-currentTemp
)*0.08
).toFixed(2)
)

};

});

},500);

return()=>clearInterval(timer);

},
[
P3701_Running,
FCV3701_Opening
]);


/* =========================================================
   TRANSMITTERS
========================================================= */

const FIC_3704 =
Number(
processData.FIC_3704 || 0
);

const PT_3704 =
Number(
processData.PT_3704 || 0.03
);

const TT_3704 =
Number(
processData.TT_3704 || 28
);





/* =========================================================
   V-3701 SUCTION FLOW
========================================================= */
const FIC_3705 = (P3701A_Running && xv3703Open) ? FIC_3704 : 0.003;

/* =========================================================
   V-3702 SUCTION FLOW
========================================================= */
const FIC_3706 = (P3701A_Running && xv3704Open) ? FIC_3704 : 0.003;











    
/* =========================================================
              SPLITTING MAIN Kerosene LINE
========================================================= */



const openKeroseneLineSplit =
[
  xv3705Open,
  xv3706Open
].filter(Boolean).length;

const FIC_3707 =
  xv3705Open
    ? FIC_3704 / openKeroseneLineSplit
    : 0;

const FIC_3708 =
  xv3706Open
    ? FIC_3704 / openKeroseneLineSplit
    : 0;





useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_3707 === FIC_3707 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_3707,
    }
  });

}, [FIC_3707, ]);















  return (
    <div className="Kerosene-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 353px",
          zIndex: 10,
        }}
      >
        Kerosene TANKS
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-3701 */}
      <Valve
        className="XV-3701"
        tag="XV_3701"
        x={314}
        y={355}
        isClosed={valves.XV_3701}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-3702 */}
      <Valve
        className="XV-3702"
        tag="XV_3702"
        x={774}
        y={355}
        isClosed={valves.XV_3702}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3703 */}
      <Valve
        className="XV-3703"
        tag="XV_3703"
        x={534}
        y={365}
        isClosed={valves.XV_3703}
        toggle={toggleValve}
      />

      {/* XV-3704 */}
      <Valve
        className="XV-3704"
        tag="XV_3704"
        x={1083}
        y={355}
        isClosed={valves.XV_3704}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3705 */}
      <Valve
        className="XV-3705"
        tag="XV_3705"
        x={1033}
        y={561}
        isClosed={valves.XV_3705}
        toggle={toggleValve}
      />

      {/* XV-3706 */}
      <Valve
        className="XV-3706"
        tag="XV_3706"
        x={1033}
        y={671}
        isClosed={valves.XV_3706}
        toggle={toggleValve}
      />



      
      <button
      
             onClick={() => {

        console.log("BUTTON CLICKED");

        setShowPerformance(true);

    }}
          style={{
              position: "absolute",
              right: "1020px",
              top: "410px",
              padding: "8px 16px",
              background: "#0b5ed7",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "bold",
              zIndex: 500
          }}
      >
          Furnace Performance Report
      </button>


      {showPerformance &&
          <FurnacePerformance
              onClose={() => setShowPerformance(false)}
          />
      }





      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-3701 */}
        <div
            style={{ position: "absolute", left: 865, top: 553}}
            onMouseEnter={() => setHoveredValve("FCV_3701")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_3701")}
          >

            {hoveredValve === "FCV_3701" && (
              <div style={tagStyle}>
                FCV_3701
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-3701">
                    
          <defs>
            <linearGradient id="metal_3701">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_3701)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_3701)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
     
      
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 370 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 370 + index * 40
              }}
            />
          ))}





      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_3701?.opening || 0)}
        x={887}
        y={600}
      />




    <Transmitter
        tag="FIC_3701"
        value={[FIC_3701]}
        x={121}
        y={325}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF FROM STABILIZER TOWER THROUGH E-304A/B TO Kerosene STORAGE TANKS)"
      />

    <Transmitter
        tag="PT_3701"
        value={[PT_3701]}
        x={181}
        y={455}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF FROM STABILIZER TOWER THROUGH E-304A/B TO Kerosene STORAGE TANKS)"
      />

      <Transmitter
        tag="FIC_3702"
        value={[FIC_3702]}
        x={281}
        y={255}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF Kerosene FROM STABILIZER TOWER THROUGH E-304A/B TO Kerosene STORAGE TANKS)"
      />

      <Transmitter
        tag="FIC_3703"
        value={[FIC_3703]}
        x={741}
        y={255}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF Kerosene FROM E-117A/B TO Kerosene STORAGE TANKS (V-303 AND V-304)"
      />

      <Transmitter
        tag="FIC_3704"
        value={[FIC_3704]}
        x={783}
        y={593}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF Kerosene FROM P-3701A/B TO LOADING OR BLENDING"
      />


      <Transmitter
        tag="PT_3704"
        value={[PT_3704]}
        x={683}
        y={593}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF Kerosene FROM P-3701A/B TO LOADING OR BLENDING"
      />
    
    <Transmitter
        tag="TT_3704"
        value={[TT_3704]}
        x={683}
        y={503}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF Kerosene FROM P-3701A/B TO LOADING OR BLENDING"
      />

      <Transmitter
        tag="FIC_3707"
        value={[FIC_3707]}
        x={1113}
        y={553}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF Kerosene FROM P-3701A/B TO LOADING GANTRY"
      />

      <Transmitter
        tag="FIC_3708"
        value={[FIC_3708]}
        x={1113}
        y={663}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF Kerosene FROM P-3701A/B TO FUEL OIL BLENDING TANK"
      />






      <LevelTransmitterIndicator
      tag="LT_3701"
      totalLevel={20000}
      inflows={[FIC_3702]}
      outflows={[FIC_3705]}
      responseFactor={0.05}
      columnX={563}
      columnY={139}
      columnWidth={30}
      columnHeight={179}
      textX={610}
      textY={150}
      showFlow={true}
      service="kerosene"
    />

    <LevelTransmitterIndicator
      tag="LT_3701"
      totalLevel={20000}
      inflows={[FIC_3702]}
      outflows={[FIC_3705]}
      responseFactor={0.05}
      columnX={396}
      columnY={139}
      columnWidth={199}
      columnHeight={181}
      textX={610}
      textY={150}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="kerosene"
    />


      <LevelTransmitterIndicator
      tag="LT_3702"
      totalLevel={20000}
      inflows={[FIC_3703]}
      outflows={[FIC_3706]}
      responseFactor={0.05}
      columnX={1009}
      columnY={139}
      columnWidth={30}
      columnHeight={179}
      textX={1050}
      textY={150}
      showFlow={true}
      service="kerosene"
    />

    <LevelTransmitterIndicator
      tag="LT_3702"
      totalLevel={20000}
      inflows={[FIC_3703]}
      outflows={[FIC_3706]}
      responseFactor={0.05}
      columnX={841}
      columnY={139}
      columnWidth={199}
      columnHeight={181}
      textX={1050}
      textY={150}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="kerosene"
    />



            <Pump
              tag="P-3701A"
              x={568}
              y={520}
              rpm={1800}
              bladeCount={pumpData?.["P-3701A"]?.bladeCount || 3}
              size={pumpData?.["P-3701A"]?.size || 45}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-3701B"
              x={568}
              y={614}
              rpm={1800}
              bladeCount={pumpData?.["P-3701B"]?.bladeCount || 3}
              size={pumpData?.["P-3701B"]?.size || 45}
              onClick={openPumpPanel}
            />






    </div>
  );
}

export default Kerosene;